// extracted by mini-css-extract-plugin
module.exports = {"container":"ReadMoreButton_container__35zuY","text":"ReadMoreButton_text__2KL3v","icon":"ReadMoreButton_icon__27W6L"};